import React from "react";
import CountUp from "react-countup";
import {
  FiKey,
  FiUsers,
  FiUserCheck,
  FiCheckCircle,
  FiCalendar,
  FiClock,
  FiAward,
  FiShield,
  FiAlertCircle,
  FiTrash2,
  FiMapPin,
  FiGlobe,
  FiActivity,
} from "react-icons/fi";
import { FaMars, FaVenus } from "react-icons/fa";
import { MdOutlineCalendarMonth, MdOutlineEventAvailable } from "react-icons/md";

const ICONS = {
  otp: FiKey,
  users: FiUsers,
  male: FaMars,
  female: FaVenus,
  activeMale: FiUserCheck,
  activeFemale: FiUserCheck,
  complete: FiCheckCircle,
  incomplete: FiAlertCircle,
  weekly: FiClock,
  monthly: FiCalendar,
  quarterly: MdOutlineCalendarMonth,
  semi: MdOutlineEventAvailable,
  admin: FiShield,
  member: FiAward,
  deleted: FiTrash2,
  singapore: FiMapPin,
  malaysia: FiMapPin,
  other: FiGlobe,
  all: FiActivity,
};

const TONE = {
  otp: { bg: "bgl-warning", text: "text-warning" },
  users: { bg: "bgl-primary", text: "text-primary" },
  male: { bg: "bgl-info", text: "text-info" },
  female: { bg: "bgl-danger", text: "text-danger" },
  activeMale: { bg: "bgl-info", text: "text-info" },
  activeFemale: { bg: "bgl-danger", text: "text-danger" },
  complete: { bg: "bgl-success", text: "text-success" },
  incomplete: { bg: "bgl-warning", text: "text-warning" },
  weekly: { bg: "bgl-primary", text: "text-primary" },
  monthly: { bg: "bgl-primary", text: "text-primary" },
  quarterly: { bg: "bgl-secondary", text: "text-secondary" },
  semi: { bg: "bgl-secondary", text: "text-secondary" },
  admin: { bg: "bgl-secondary", text: "text-secondary" },
  member: { bg: "bgl-warning", text: "text-warning" },
  deleted: { bg: "bgl-danger", text: "text-danger" },
  singapore: { bg: "bgl-danger", text: "text-danger" },
  malaysia: { bg: "bgl-success", text: "text-success" },
  other: { bg: "bgl-info", text: "text-info" },
  all: { bg: "bgl-primary", text: "text-primary" },
};

function DashboardStatCard({
  title,
  value = 0,
  icon = "users",
  onClick,
  duration = 1.5,
}) {
  const Icon = ICONS[icon] || FiUsers;
  const tone = TONE[icon] || TONE.users;

  return (
    <div className="col-xl-3 col-xxl-3 col-lg-6 col-md-6 col-sm-6">
      <div
        className={`widget-stat card dashboard-stat ${onClick ? "pointer" : ""}`}
        onClick={onClick}
        role={onClick ? "button" : undefined}
        tabIndex={onClick ? 0 : undefined}
        onKeyDown={
          onClick
            ? (e) => {
                if (e.key === "Enter" || e.key === " ") onClick();
              }
            : undefined
        }
      >
        <div className="card-body p-4">
          <div className="media ai-icon align-items-center">
            <span className={`me-3 bgl-icon ${tone.bg} ${tone.text}`}>
              <Icon size={26} />
            </span>
            <div className="media-body">
              <h3 className="mb-0 dashboard-stat__value">
                <CountUp
                  start={0}
                  end={Number(value) || 0}
                  duration={duration}
                />
              </h3>
              <p className="mb-0 dashboard-stat__label">{title}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardStatCard;
